import MDEditor from '@uiw/react-md-editor';
import styled from 'styled-components';

export const StyledMDEditor = styled(MDEditor)`
	width: 100%;
	background-color: #f8f9fa;

	.w-md-editor-toolbar {
		--color-fg-default: #2c4b56;
		--color-accent-fg: #253d33;

		background-color: #b7c9e2;
	}
`;

export const PreviewImage = styled.img`
	max-width: 100%;
	max-height: 420px;
`;

export const PostElementsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
`;

export const PostElementContainer = styled.div`
	width: 100%;

	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const VideoUrlInput = styled.input`
	width: 100%;
	padding: 10px 12px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 1rem;
	background-color: #fff;
	color: #333;
	box-sizing: border-box;

	&::placeholder {
		color: #999;
	}

	&:focus {
		outline: none;
		border-color: #2c4b56;
		box-shadow: 0 0 0 2px rgba(44, 75, 86, 0.2);
	}
`;

export const VideoPreview = styled.video`
	max-width: 100%;
	max-height: 420px;
	border-radius: 8px;
	margin-bottom: 8px;
`;
